<div class="position-relative w-100 padding">
  <app-header-detail></app-header-detail>
  <app-sub-detail></app-sub-detail>
  <app-culture-detail></app-culture-detail>
  <app-jobs-detail></app-jobs-detail>
</div>
